/*
 * Mobile - Side Cart - Urgency  --  variant: Urgency Social Proof
 * Moonshot experiment id: 78301092   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-10-03
 * Audience: MOBILE   Target: side_cart   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_sc_m_urgency
 */
MGExp.run('sc_m_urgency', { name: "Mobile - Side Cart - Urgency / Urgency Social Proof", platform: 'mobile', target: 'side_cart' }, function () {
  !(function () {
    let i = [],
      t = [];
    async function e(e, n, s, a, r) {
      let c = {
        multi_target_selectors: i,
        page_identifier_selector: "#mini-cart-modal",
        exclude_from_timeout: t,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(e, n, s, a, r, c);
    }
    t.push(
      ".msai-urgency-banner",
      "#mini-cart-items-list li.empty",
      "#mini-cart-items-list li:not(.empty)",
    );
    const n =
      ".msai-urgency-banner{background:#F8ECD5;color:#483927;font-family:'Inter','Segoe UI',Arial,sans-serif;font-size:14px;border-radius:10px;margin:12px 0 20px 0;padding:10px 16px;display:flex;align-items:center;box-shadow:0 1px 4px rgba(30,20,8,0.09)}";
    (e(
      [".bag-title", "#mini-cart-items-list li:not(.empty)"],
      ".msai-urgency-banner",
      function (i, t) {
        const [e, n] = t;
        (e.classList.add("msai-side-cart-urgency"),
          e.insertAdjacentHTML(
            "afterend",
            '\n          <div class="msai-urgency-banner">\n            <svg width="18" height="18" style="margin-right:10px;flex:0 0 auto;" fill="none" stroke="#E4C590" stroke-width="1.8" viewBox="0 0 24 24">\n              <path d="M12 3v3M12 18v3M21 12h-3M6 12H3M16.95 7.05l-2.12 2.12M7.05 16.95l-2.12-2.12M16.95 16.95l-2.12-2.12M7.05 7.05l2.12 2.12" stroke-linecap="round"/>\n              <circle cx="12" cy="12" r="4.2" stroke="#95764A" />\n            </svg>\n            <span>Your cart includes items that are currently high in demand.</span>\n          </div>\n        ',
          ));
      },
      n,
    ),
      e(
        ["#mini-cart-items-list li.empty", ".msai-urgency-banner"],
        ".msai-side-cart-empty",
        function (i, t) {
          const [e, n] = t;
          (n.remove(), e.classList.add("msai-side-cart-empty"));
        },
        n,
      ));
  })();
});
